import Vue from 'vue'
import App from './App.vue'
import { retrievedQuestions } from './util/saved'
 
Vue.config.productionTip = false;

const main = new Vue({
    data: {
        currentRoute : window.location.pathname,
        cards: [],
        categories: [],
        history: [{current: 'home'}],
        cardHistory: []
    },
    mounted: async function(){
        const res = await fetch(window.location.origin+'/cards.json');
        this.cards = await res.json();
        const res2 = await fetch(window.location.origin+'/categories.json');
        this.categories = await res2.json();
    },
    computed: {
        appState (){
            let matchingUrl = '';
            let strings = [];
            const route = this.currentRoute;
            // Derive App state from url or current state
            if(route === '/cat' || route === '/cat/') {
                //Get the list of all the categories
                return {current: 'categories', name: 'Toutes les catégories', list: this.categories};

            } else if(/\/cat\/[^/]*/g.test(route)){
                //Get the list of card in the current category
                matchingUrl = /\/cat\/[^/]*/g.exec(this.currentRoute)[0];
                strings = matchingUrl.split('/');
                let category = strings[strings.length-1];
                let categoryIndex = 0;
                for(let i = 1; i<this.categories.length; i++){
                    //Find category id from name
                    if(this.categories[i].name.toLowerCase().trim() === category.toLowerCase().trim()) categoryIndex = i;
                }
                let categoryCards = [];
                for(let i = 0; i<this.cards.length; i++) {
                    //Get cards having the category id in their tags
                    let currentCard = this.cards[i];
                    if(currentCard['tags'].includes(categoryIndex)) categoryCards.push({id: currentCard.id, name: currentCard.recto});
                }
                return {current: 'category', name: category, list: categoryCards};

            } else if(/\/card\/\d*/g.test(route)){
                //Get the card for the specified id
                matchingUrl = /\/card\/\d*/g.exec(this.currentRoute)[0];
                strings = matchingUrl.split('/');
                let id = strings[strings.length-1] || 0;
                let card;
                if(this.cards.length < id){
                    id= 0;
                    card = this.cards[0];
                } else{
                    card = this.cards[id]
                }
                return {current: 'card', card: card, id:id};
            } else if(route === '/liked'){
                const liked = retrievedQuestions()
                const likedCards = [];
                if(liked !== null){
                    for(let i = 0; i<this.cards.length; i++) {
                        //Get cards having the category id in their tags
                        let currentCard = this.cards[i];
                        if(liked.includes(currentCard.id.toString())) likedCards.push({id: currentCard.id, name: currentCard.recto});
                    }
                }
                return {current: 'liked', name: 'Cartes sauvegardées', list: likedCards};
            } else if(route === '/about'){
                //Go to about screen
                return {current: 'about'};

            } else {
                //Go to home screen
                return {current: 'home'};
            }
        }
    },
    methods: {
        switchState: function(state){
            const halfLength = Math.floor(this.cards.length / 2);
            let random = 0;
            if(this.cards.length % 2 === 0){
                random = this.cardHistory[this.cardHistory.length-1] >= this.cards.length / 2 ? Math.floor(Math.random() * halfLength) : Math.floor(Math.random() * halfLength) + halfLength;
            } else {
                random = this.cardHistory[this.cardHistory.length-1] >= this.cards.length / 2 ? Math.floor(Math.random() * halfLength) : Math.floor(Math.random() * (halfLength + 1)) + halfLength;
            }
            switch (state.new) {
                case 'home':
                default:
                    this.currentRoute = '/';
                    history.pushState({page: 1}, "home", "/");
                    break;
                case 'card':
                    this.currentRoute = '/card/' + state.id;
                    history.pushState({page: 1}, "home", "/card/" + state.id);
                    break;
                case 'random':
                    this.currentRoute = '/card/'+random;
                    history.pushState({page: 1}, "card", "/card/"+random);
                    break;
                case 'about':
                    this.currentRoute = '/about';
                    history.pushState({page: 1}, "about", "/about");
                    break;
                case 'categories':
                    this.currentRoute = '/cat';
                    history.pushState({page:1}, "cat", "/cat");
                    break;
                case 'category':
                    this.currentRoute = '/cat/' + state.name;
                    history.pushState({page:1}, "catcard", "/cat/"+state.name);
                    break;
                case 'liked':
                    this.currentRoute = '/liked'
                    history.pushState({page:1}, "like", "/liked")

            }
        },
        previous: function(){
            const old = this.history[this.history.length-2];
            this.history.pop();
            this.history.pop();
            this.switchState({...old, new: old.current});
        }
    },
    watch: {
        appState: function(val){
            const old = this.history[this.history.length-1];
            if(JSON.stringify(val) !== JSON.stringify(old) && !(val.current === 'card' && old.current === 'card')){
                if(this.history.length > 5){
                    this.history.shift();
                }
                this.history.push(val);
            }
            if(val.current === "card"){
                if(this.cardHistory.length > 5){
                    this.cardHistory.shift();
                }
                this.cardHistory.push(val.id);
            }
        }
    },
    render: function(h){
        return h(App, {props :{state: this.appState, switchState: this.switchState, previous: this.previous}})
    },
}).$mount('#app');

window.addEventListener('popstate', () => {
    main.currentRoute = window.location.pathname
});

export function nextRandom(){
    main.switchState({new: 'random'});
}